import { attr, cn, html, LpButton, LpDataTable, LpEmpty, LpIcon, LpTable } from '~/design-system';
export function renderKoTextCell({ column, binding, className, contentClassName, contentStyle, titleBinding, }) {
    const titleAttr = titleBinding
        ? `, attr: { title: ${titleBinding} }`
        : '';
    return LpTable.Cell({
        column,
        className,
        children: html `
            <span
                class="${cn('lp-table_cell-content', contentClassName)}"
                ${attr('style', contentStyle)}
                data-bind="text: ${binding}${titleAttr}"
            ></span>
        `,
    });
}
export function renderKoInputCell({ column, binding, className, type = 'text', step, }) {
    return LpTable.Cell({
        column,
        className,
        children: html `<input class="edit-input" type="${type}" ${step ? `step="${step}"` : ''} data-bind="value: ${binding}" />`,
    });
}
export function renderKoEditActionCell({ column, binding, className, ariaLabel = 'Edit', icon = 'pencil-simple', }) {
    return LpTable.Cell({
        column,
        className,
        children: html `
            ${LpButton({
            ariaLabel,
            prefixIcon: icon,
            size: 'sm',
            shape: 'square',
            variant: 'ghost',
            className: 'list-edit-action',
            attributes: {
                'data-bind': binding,
            },
        })}
        `,
    });
}
export function renderKoActionButtonsCell({ column, actions, className, rowClassName = 'list-page-row-actions', }) {
    return LpTable.Cell({
        column,
        className,
        children: html `
            <div class="${rowClassName}">
                ${actions.map((action) => LpButton({
            ariaLabel: action.ariaLabel,
            prefixIcon: action.icon,
            size: 'sm',
            shape: 'square',
            variant: 'ghost',
            className: 'list-edit-action',
            attributes: {
                'data-bind': action.binding,
            },
        }))}
            </div>
        `,
    });
}
export function renderKoDataTable({ title, titleIcon, caption, columns, children, actions, className, showColumnMenu = false, stickyHeader = true, }) {
    const tableTitle = titleIcon
        ? html `
            <span class="lp-data-table_layer-title-content">
                ${LpIcon({ name: titleIcon, size: 16, className: 'lp-data-table_layer-title-icon' })}
                <span>${title}</span>
            </span>
        `
        : title;
    return String(LpDataTable({
        title: tableTitle,
        caption,
        columns,
        actions,
        showColumnMenu,
        stickyHeader,
        className,
        children,
    }));
}
export function renderKoEmptyState({ colSpan, visibleBinding, title, description, icon = 'folder-simple', }) {
    return LpTable.StateBody({
        colSpan,
        attributes: {
            'data-bind': `visible: ${visibleBinding}`,
            style: 'display: none;',
        },
        children: LpEmpty({
            title,
            description,
            icon,
            size: 'sm',
        }),
    });
}
